export const ORDER_TAGS_LIMIT = 8;

/** Считает уникальные непустые теги так же, как их воспринимает пользователь. */
export function parseTagInput(value: string): string[] {
  return [
    ...new Set(
      value
        .split(',')
        .map((tag) => tag.trim().toLowerCase().replace(/\s+/g, ' '))
        .filter(Boolean),
    ),
  ];
}

export function tagInputError(value: string): string | undefined {
  const count = parseTagInput(value).length;
  return count > ORDER_TAGS_LIMIT ? `Не больше ${ORDER_TAGS_LIMIT} тегов` : undefined;
}
